import { AlarmClock } from 'lucide-react';
import { CardShell, EmptyState } from './card-shell';

export function UpcomingDeadlinesCard() {
  return (
    <CardShell title="Prazos próximos" icon={AlarmClock}>
      <EmptyState
        icon={AlarmClock}
        message="Sem prazos próximos."
        cta={{ label: 'Ver agenda', href: '/escritorio/agenda' }}
      />
    </CardShell>
  );
}
